"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : POPUP : STYLES --------------- ++++++++++ */


var _default = {
  popupmessage: {
    maxWidth: (0, _index.pxToEm)(432),
    padding: (0, _index.pxToEm)(18),
    //copy
    '& .title': {
      fontSize: (0, _index.pxToEm)(12),
      margin: '0' // width: '70%'

    },
    '& .bodycopy': {
      fontSize: (0, _index.pxToEm)(14) // textAlign: 'center',
      // width: '80%'

    },
    //CTAs
    '& .ctas': {
      '& .button': {
        width: '100%',
        marginBottom: (0, _index.pxToEm)(10)
      }
    }
  }
};
exports.default = _default;